import { isTuchongApp } from './ua';
import toUpgrade from './toUpgrade';

export default ua => ({
    webkit: !!ua.match(/WebKit/gi),
    isMobile: !!ua.match(/Mobile/gi),
    iOS: !!ua.match(/(iPad|iPhone|iPod)/gi),
    android: !!ua.match(/Android/gi),
    iOSSafari: !!ua.match(/WebKit/gi)
               && !!ua.match(/(iPad|iPhone|iPod)/gi)
               && !(/CriOS/gi).test(ua)
               && !(/FxiOS/gi).test(ua)
               && !(/OPiOS/gi).test(ua)
               && !(/mercury/gi).test(ua),
    wechat: !!ua.match(/micromessenger/gi),
    weibo: !!ua.match(/weibo/gi),
    tuchong: !!ua.match(/Tuchong/gi),
    everphoto: !!ua.match(/EverPhoto/gi),
    alipay: !!ua.match(/AlipayClient/gi),
});


/**
 * @desc 通过 UA 获取图虫客户端版本，获取不到返回空字符串
 */
export const appVersion = () => {
    let version = '';
    if (isTuchongApp()) {
        const ua = navigator.userAgent;
        if (ua.indexOf('Tuchong') > -1) {
            /* eslint-disable */
          version = ua.split('Tuchong/')[1].split('(')[0];
          /* eslint-enable */
        } else {
            version = '0.0.0';
        }
    }
    return version;
};


/**
 * @desc 判断是否未 IPhoneX
 */
export const isIphoneX = () => {
    if (typeof window !== 'undefined' && window) {
        return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
    }
    return false;
};

export function goldDesc() {
    return '积分';
}
